module.exports = __webpack_public_path__ + "static/media/cn.30d7ee5d.svg";